import React, { useState } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { PROVIDER_LOGO } from './visual';
import type { ProviderKey } from './types';

interface Props {
  title: string;
  /** Aggregate display source — drives the small text tag in the header. */
  source: string;
  /** Brand provider — drives the per-row logo. */
  provider?: ProviderKey;
  /** Optional left-edge bar color override (channel accent). */
  accent?: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

export function ActivityAccordion({
  title, source, provider, accent, defaultOpen = false, children,
}: Props) {
  const { isDark } = useTheme();
  const [open, setOpen] = useState(defaultOpen);
  const logo = provider ? PROVIDER_LOGO[provider] : null;
  const barColor = accent ?? 'var(--card-border)';

  return (
    <section className="border border-[var(--card-border)]">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-2 px-3 py-2 text-left"
      >
        <span
          aria-hidden
          className="block w-1 h-6"
          style={{ backgroundColor: barColor }}
        />
        {logo && (
          <img
            src={isDark ? logo.dark : logo.light}
            alt={`${provider} logo`}
            data-testid={`provider-logo-${provider}`}
            className="w-4 h-4 object-contain shrink-0"
          />
        )}
        <span className="font-medium cgm-text-primary flex-1">{title}</span>
        <span className="text-xs cgm-text-muted">{source}</span>
      </button>
      {open && <div className="px-3 pb-3">{children}</div>}
    </section>
  );
}
